import React, { Component } from 'react'
import { Switch, Route, Redirect } from 'react-router-dom'

import { connect } from 'react-redux';
import { store, history } from '../store/configureStore'
import { push } from 'react-router-redux';

import agent from '../agent'
import AuxContainer from './AuxContainer'

import { APP_LOAD, REDIRECT } from '../constants/actionTypes';

import ClientLoginContainer from './ClientLoginContainer'
import ClientProjectsListContainer from './ClientProjectsListContainer'
import ClientProjectSettingsContainer from './ClientProjectSettingsContainer'

class ClientContainer extends Component {
	// componentWillReceiveProps(nextProps) {
	// 	if (nextProps.redirectTo) {
	// 		store.dispatch(push(nextProps.redirectTo))
	// 		this.props.onRedirect();
	// 	}
	// }

	// componentWillMount() {
	// 	const clientToken = localStorage.getItem('jwt') ?  JSON.parse(localStorage.getItem('jwt')) : null
	// 	if (clientToken && clientToken.token) {
	// 		// agent.setToken(token);
	// 		history.push('/projects')
	// 	}
	// 	this.props.onLoad(clientToken)
	// }

	render() {
		const { match } = this.props
		return (
			<AuxContainer>
				<Switch>
			    <Route path={`${match.path}/login`} exact component={ClientLoginContainer} />
			    <Redirect to={`${match.path}/login`} />
			  </Switch>
			</AuxContainer>
		)
	}
}

const mapStateToProps = state => ({
	...state.common,
	...state.auth,
	...state.client,
})

const mapDispatchToProps = dispatch => ({
	onLoad: (clientToken) =>
		dispatch({ type: APP_LOAD, clientToken }),
	onRedirect: () =>
		dispatch({ type: REDIRECT }),
	onClickLogout: () =>
		dispatch({ type: 'LOGOUT' })
})

export default connect(mapStateToProps, mapDispatchToProps)(ClientContainer)






// WEBPACK FOOTER //
// ./src/containers/ClientContainer.js